import { map, lensPath } from 'ramda';
import * as RA from 'ramda-adjunct';

// export const createCalendarDateArtists = ({
//   artist_after = '',
//   artist_before = '',
//   artist_id = '',
//   artist_name = '',
//   booking_location_name = '',
//   booking_location_stage_id = '',
//   booking_location_stage_name = '',
//   calendar_date_artist_id = '',
//   capacity = '',
//   catering = '',
//   cd_end_date = '',
//   city = '',
//   confirmed_flag = '',
//   date_hotel_end = '',
//   date_hotel_start = '',
//   default_catering_eng = '',
//   default_double_rooms = '',
//   default_hotel_eng = '',
//   default_performance_time_contract = '',
//   default_single_rooms = '',
//   default_suites = '',
//   default_techrider_eng = '',
//   default_travel_eng = '',
//   default_travel_options = '',
//   default_travel_qty = '',
//   description = '',
//   double_rooms = '',
//   guestlist = '',
//   guestlist_tickets = '',
//   hotel_class = '',
//   hotel_stars = '',
//   last_modified = '',
//   performance_time = '',
//   performance_time_contract = '',
//   performance_type = '',
//   playlist_id = '',
//   powersupply = '',
//   schedule_notes = '',
//   single_rooms = '',
//   soundcheck = '',
//   stage_depth = '',
//   stage_height = '',
//   stage_length = '',
//   stage_name = '',
//   start_date = '',
//   suites = '',
//   techrider = '',
//   travel_class = '',
//   travel_option2 = '',
//   travel_options = '',
//   travel_qty = '',
// } = {}) => {
//   return {
//     artist_after,
//     artist_before,
//     artist_id,
//     artist_name,
//     booking_location_name,
//     booking_location_stage_id,
//     booking_location_stage_name,
//     calendar_date_artist_id,
//     capacity,
//     catering,
//     cd_end_date,
//     city,
//     confirmed_flag,
//     date_hotel_end,
//     date_hotel_start,
//     default_catering_eng,
//     default_double_rooms,
//     default_hotel_eng,
//     default_performance_time_contract,
//     default_single_rooms,
//     default_suites,
//     default_techrider_eng,
//     default_travel_eng,
//     default_travel_options,
//     default_travel_qty,
//     description,
//     double_rooms,
//     guestlist,
//     guestlist_tickets,
//     hotel_class,
//     hotel_stars,
//     last_modified,
//     performance_time,
//     performance_time_contract,
//     performance_type,
//     playlist_id,
//     powersupply,
//     schedule_notes,
//     single_rooms,
//     soundcheck,
//     stage_depth,
//     stage_height,
//     stage_length,
//     stage_name,
//     start_date,
//     suites,
//     techrider,
//     travel_class,
//     travel_option2,
//     travel_options,
//     travel_qty,
//   }
// };


export const createCalendarDateArtist = ({
  artist_after = '',
  artist_before = '',
  artist_id = '',
  booking_location_stage_id = '',
  booking_status_id = '',
  calendar_date_artist_id = '',
  calendar_date_id = '',
  catering = '',
  catering2 = '',
  confirmed_flag = '',
  contract_flag = '',
  created = '',
  date_hotel_end = '',
  date_hotel_start = '',
  double_rooms = '',
  first_offer_notes = '',
  guestlist = '',
  guestlist_tickets = '',
  hotel_class = '',
  hotel_class2 = '',
  hotel_stars = '',
  invoice_line_id_add_ded = '',
  invoice_line_id_bookfee = '',
  invoice_line_id_commission = '',
  invoice_line_id_deposit = '',
  invoice_line_id_deposit2 = '',
  invoice_line_id_fee = '',
  last_modified = '',
  performance_time = '',
  performance_time_contract = '',
  performance_type = '',
  playlist_id = '',
  schedule_notes = '',
  setup_time = '',
  single_rooms = '',
  soundcheck = '',
  stage_name = '',
  suites = '',
  techrider = '',
  techrider2 = '',
  travel_class = '',
  travel_class2 = '',
  travel_option2 = '',
  travel_options = '',
  travel_qty = '',
} = {}) => {
  return {
    artist_after,
    artist_before,
    artist_id,
    booking_location_stage_id,
    booking_status_id,
    calendar_date_artist_id,
    calendar_date_id,
    catering,
    catering2,
    confirmed_flag,
    contract_flag,
    created,
    date_hotel_end,
    date_hotel_start,
    double_rooms,
    first_offer_notes,
    guestlist,
    guestlist_tickets,
    hotel_class,
    hotel_class2,
    hotel_stars,
    invoice_line_id_add_ded,
    invoice_line_id_bookfee,
    invoice_line_id_commission,
    invoice_line_id_deposit,
    invoice_line_id_deposit2,
    invoice_line_id_fee,
    last_modified,
    performance_time,
    performance_time_contract,
    performance_type,
    playlist_id,
    schedule_notes,
    setup_time,
    single_rooms,
    soundcheck,
    stage_name,
    suites,
    techrider,
    techrider2,
    travel_class,
    travel_class2,
    travel_option2,
    travel_options,
    travel_qty,
  }
};


export const makeTravelOptionItems = map(travelOption => 
  travelOption.travel_option_text
);

const playlistsLens = lensPath(['data', 'playlists']);
export const getPlaylistsResponse = RA.viewOr([], playlistsLens);

export const playlistsTextValue = (items = []) => {
  return [
    ...items.map(item => ({
    text: item.playlist_name,
    value: item.booking_artist_playlist_id
    })),
  ];
}